import { render, staticRenderFns } from "./Treasury.vue?vue&type=template&id=06cdc624&"
import script from "./Treasury.vue?vue&type=script&lang=js&"
export * from "./Treasury.vue?vue&type=script&lang=js&"
import style0 from "./Treasury.vue?vue&type=style&index=0&style=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports